import React from 'react';
import styled from 'styled-components';
import { Box, Flex, Relative, Absolute, getPaletteColor } from 'pcln-design-system';
import { TripSummaryCard } from '@pcln/cards';
import { Plus } from 'pcln-icons';
import { HotelsOutlineGreenOnGreen, FlightsOutlineGreenOnGreen, CarsOutlineGreenOnGreen } from '@pcln/brand';
const IconWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CrossSellCard__IconWrapper",
  componentId: "sc-1hobnds-0"
})(["border:1px dashed ", ";"], props => getPaletteColor('success.dark')(props));
const getActionText = crossSellProduct => {
  switch (crossSellProduct) {
    case 'STAY':
      return 'Search Hotels';
    case 'FLY':
      return 'Search Flights';
    case 'DRIVE':
      return 'Search Cars';
  }
};
const getProductString = productType => {
  switch (productType) {
    case 'STAY':
      return 'hotel';
    case 'FLY':
      return 'flight';
    case 'DRIVE':
      return 'rental car';
  }
};
const IconComponent = ({
  crossSellProduct
}) => {
  switch (crossSellProduct) {
    case 'STAY':
      return React.createElement(HotelsOutlineGreenOnGreen, {
        size: '32px',
        title: 'hotel-icon'
      });
    case 'FLY':
      return React.createElement(FlightsOutlineGreenOnGreen, {
        size: '32px',
        title: 'flight-icon'
      });
    case 'DRIVE':
      return React.createElement(CarsOutlineGreenOnGreen, {
        size: '32px',
        title: 'car-icon'
      });
  }
};
export const CrossSellIcon = ({
  crossSellProduct
}) => React.createElement(Relative, null, React.createElement(IconWrapper, {
  p: 1,
  borderRadius: 'full'
}, React.createElement(Flex, {
  px: 2,
  borderRadius: 'full',
  bg: 'highlight.light'
}, React.createElement(Box, {
  mt: 2
}, React.createElement(IconComponent, {
  crossSellProduct: crossSellProduct
})))), React.createElement(Absolute, {
  bottom: 0,
  right: 0
}, React.createElement(Flex, {
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.lightest',
  bg: 'success.dark',
  height: '16px',
  width: '16px',
  borderRadius: 'full'
}, React.createElement(Plus, {
  color: 'text.lightest',
  size: 24
}))));
/** @public */
const CrossSellCard = ({
  className,
  crossSellProduct,
  primaryProduct,
  hoverBoxShadowSize,
  showArrowRight,
  onClick,
  handleSubmitCTA,
  headingOverride,
  captionOverride,
  actionTextOverride
}) => {
  return React.createElement(TripSummaryCard, {
    className: className,
    hoverBoxShadowSize: hoverBoxShadowSize,
    mediaNode: React.createElement(CrossSellIcon, {
      crossSellProduct: crossSellProduct
    }),
    mediaNodeBackgroundColor: 'transparent',
    heading: headingOverride || `Add a ${getProductString(crossSellProduct)} to your trip`,
    caption: captionOverride || `Your ${getProductString(primaryProduct)} booking unlocks up to 40% off ${getProductString(crossSellProduct)}s`,
    actionText: actionTextOverride || getActionText(crossSellProduct),
    truncateHeading: true,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA
  });
};
export default CrossSellCard;